import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRespuestasNovedades } from "../../../../actions/connectivityResponse";
import CustomDialog from "../../../commons/dialog/customDialog";

const RespuestasNovedadesDialog = ({ respuesta, open, handleClose }) => {
  const dispatch = useDispatch();

  const respuestasNovedades = useSelector(
    (state) => state.connectivityResponse.searchConnectivityResponses,
  );

  const isLoading = respuestasNovedades.isFetching;

  useEffect(() => {
    if (respuesta) {
      dispatch(getRespuestasNovedades(respuesta));
    }
  }, [respuesta]);
  return (
    <CustomDialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Registro de Respuestas</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <CircularProgress />
        ) : respuestasNovedades.data.length ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      paddingRight: 20,
                    }}>
                    Error
                  </TableCell>
                  <TableCell>Detalle</TableCell>
                  <TableCell>Fecha Procesado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {respuestasNovedades.data.map((log, index) => (
                  <TableRow key={index}>
                    <TableCell>{log.error ? "Si" : "No"}</TableCell>
                    <TableCell>{log.detalle}</TableCell>
                    <TableCell>
                      {moment(log.fechaHoraProcesado).format("DD/MM/YYYY, HH:mm")}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography>No hay registros disponibles.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default RespuestasNovedadesDialog;
